// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gj-0";
export var headerCellHover = "_gj-1";
export var readCellContainer = "_gj-2";
export var unreadIndicator = "_gj-3";